import { render, staticRenderFns } from "./TaskUpdatedMentionNotification.vue?vue&type=template&id=164b0fae"
import script from "./TaskUpdatedMentionNotification.vue?vue&type=script&lang=js"
export * from "./TaskUpdatedMentionNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports